import { zodSchemes } from '@approvalmax/utils';
import { CurrencyIsoCode, TransactionStatus } from 'shared/data/wallets/v1';
import { z } from 'zod';

export const schema = z.object({
    currencies: z.array(z.nativeEnum(CurrencyIsoCode)).nullish(),
    statuses: z.array(z.nativeEnum(TransactionStatus)).nullish(),
    createdAtGte: z.date().nullish(),
    createdAtLte: z.date().nullish(),
    accountAmountGte: zodSchemes.optional.numberField.number,
    accountAmountLte: zodSchemes.optional.numberField.number,
});
